'use client';
import clsx from 'clsx';
import { useState } from 'react';
import { Button, Disclosure, DisclosurePanel } from 'react-aria-components';
/**
 * Display an interactive OpenAPI disclosure.
 */
export function OpenAPIDisclosure(props) {
    var icon = props.icon, children = props.children, label = props.label, className = props.className;
    var _a = useState(false), isExpanded = _a[0], setIsExpanded = _a[1];
    return (<Disclosure className={clsx('openapi-disclosure', className)} isExpanded={isExpanded} onExpandedChange={setIsExpanded}>
            <Button slot="trigger" className="openapi-disclosure-trigger" style={function (_a) {
            var isFocusVisible = _a.isFocusVisible;
            return ({
                outline: isFocusVisible
                    ? '2px solid rgb(var(--primary-color-500) / 0.4)'
                    : 'none',
            });
        }}>
                {icon}
                <span>{typeof label === 'function' ? label(isExpanded) : label}</span>
            </Button>
            <DisclosurePanel className="openapi-disclosure-panel">
                {isExpanded ? children : null}
            </DisclosurePanel>
        </Disclosure>);
}
